/**
 * sun-product-accordion.js — Accordéons fiche produit : un seul ouvert à la fois
 *
 * Chaque block Accordion rend son propre <collapsible-elements> avec un seul
 * <details>, donc l'attribut natif `single` du thème ne peut pas fermer les
 * autres blocks. On réutilise l'évènement `theme:collapsible:toggle`
 * (theme.dev.js) et l'API `close()` du host <collapsible-elements>.
 *
 * Scope : `.sun-product-section` (product-info dans sections/sun-product.liquid).
 * Chargé depuis cette section.
 */
(function () {
  const scopeSelector = '.sun-product-section';

  document.addEventListener('theme:collapsible:toggle', (event) => {
    const collapsible = event.target?.closest?.('[data-collapsible]');
    if (!collapsible) return;

    const scopeRoot = collapsible.closest(scopeSelector);
    if (!scopeRoot) return;

    if (collapsible.getAttribute('open') !== 'true') return;

    for (const host of scopeRoot.querySelectorAll('collapsible-elements')) {
      const openSibling = host.querySelector('[data-collapsible][open="true"]');
      if (!openSibling || openSibling === collapsible) continue;
      if (typeof host.close === 'function') host.close(openSibling);
    }
  });
})();
